import { render, staticRenderFns } from "./account.vue?vue&type=template&id=2b1f18c2"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./account.vue?vue&type=style&index=0&id=2b1f18c2&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "2e306342"
  
)

export default component.exports